import { render, staticRenderFns } from "./Eventos-List.vue?vue&type=template&id=edd79a10"
import script from "./Eventos-List.vue?vue&type=script&lang=js"
export * from "./Eventos-List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports